import { I18n } from "@assets/strings";
import React from "react";
import { useHistory } from "@core/routing/useHistory";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { useIsLearner, useOrganizationAlias } from "@domain/currentProfile/hooks";
import { useOrganistationShareroom } from "@domain/organization/hooks";
import { RoundedPlusButton } from "@ui/components/buttons/roundedPlusButton";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { DiscussionThumbnail } from "@ui/components/group/discussionThumbnail";
import { ShareroomThumbnail } from "@ui/components/group/shareroomThumbnail";
import { InfiniteScroll } from "@ui/components/infiniteScroll";
import { row, stack } from "@ui/components/layout";
import { mobile } from "@ui/styles/utils";
// import { ShareroomThumbnailUtraSmall } from "../../components/group/shareroomThumbnailUtraSmall";

interface OrganizationSharerromProps extends React.HTMLAttributes<HTMLDivElement> {
	organisationId: string;
	organisationSlug?: string;
}

export const OrganizationShareroom: React.FC<OrganizationSharerromProps> = ({ organisationId, ...htmlProps }) => {
	const { result: groups, loading, fetchMore, moreLoading } = useOrganistationShareroom(organisationId);

	const alias = useOrganizationAlias();
	const isLearner = useIsLearner();
	const history = useHistory();

	return (
		<Container {...htmlProps}>
			<SubtitleContainer>
				<Subtitle>
					<span>{I18n.t("organization.tab.shareroom")}</span>
				</Subtitle>
				{alias && !isLearner ? (
					<RoundedPlusButton
						onClick={() => history.push(Path.GroupEditor("new", "SHAREROOM", organisationId))}
						label={"Ajouter une classe"}
					/>
				) : null}
			</SubtitleContainer>
			<StyledInfiniteScrool onEndReached={fetchMore} loading={loading || moreLoading}>
				{groups.map((group) =>
					group.type === "SHAREROOM" ? (
						<ShareroomStyledThumbnail key={group.id} shareroom={group} />
					) : (
						<DiscussionStyledThumbnail key={group.id} discussion={group} />
					)
				)}
			</StyledInfiniteScrool>
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	${stack(40)}
	padding: 30px 40px;
`;

const SubtitleContainer = styled.div`
	${row(10, "space-between", "center")};
	margin-bottom: 20px;
	width: 100%;
`;

const Subtitle = styled.div`
	${row(10, "flex-start", "center")};
	> span {
		${({ theme }) => theme.textStyles.subtitle};
		color: ${({ theme }) => theme.colors.secondary};
	}
	> svg {
		display: block;
		cursor: pointer;
		path {
			fill: ${({ theme }) => theme.colors.secondary};
		}
	}

	@media ${mobile} {
		> span {
			flex: 0 1;
		}
	}
`;

const ShareroomStyledThumbnail = styled(ShareroomThumbnail)`
	width: 100%;
`;
const DiscussionStyledThumbnail = styled(DiscussionThumbnail)`
	width: 100%;
`;

const StyledInfiniteScrool = styled(InfiniteScroll)`
	width: 100%;
	${stack(40)}
`;
